import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    margin: 0.5em 0;\n\n    input {\n        cursor: pointer;\n        display: none;\n    }\n'], ['\n    display: flex;\n    margin: 0.5em 0;\n\n    input {\n        cursor: pointer;\n        display: none;\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    color: ', ';\n    display: flex;\n    align-items; center;\n'], ['\n    color: ', ';\n    display: flex;\n    align-items; center;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    background: none;\n    cursor: pointer;\n    text-align: left;\n'], ['\n    background: none;\n    cursor: pointer;\n    text-align: left;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    text-decoration: underline;\n'], ['\n    text-decoration: underline;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    text-decoration: none;\n    color: ', ';\n    margin-left: 6px;\n'], ['\n    text-decoration: none;\n    color: ', ';\n    margin-left: 6px;\n']);

import styled from 'styled-components';

export var StyledListItemContainer = styled.label(_templateObject);

export var StyledListItemProduct = styled.div(_templateObject2, function (props) {
    return props.theme.dormifyGrey;
});

export var StyledListItemProductLink = styled.button(_templateObject3);

export var StyledListItemName = styled.span(_templateObject4);

export var StyledListItemPrice = styled.span(_templateObject5, function (props) {
    return props.theme.dormifyGrey;
});